import React, { useState } from 'react'
import Modal from '../components/book/steps/components/Modal'
import { Text, Header2 } from '../styles/Components'
import Button from './Button'
import { gsColors } from '../styles/Variables'
import styled from '@emotion/styled'
import { mq } from '../helpers'

const DeleteAddressContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem 1.5rem 1rem;

  h2 {
    max-width: 85%;
    text-align: center;
    margin-bottom: 48px;

    ${mq('max', '')}
  }

  #custom-title {
    margin: 15px;
  }

  div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
  }
`

const DeleteModal = ({
  isDesktop,
  isOpen,
  closeModal,
  deleteFn,
  cancelConfirmText,
  lateCancel,
  cancelSuccess,
  setCancelWorking,
  customError = false,
  customErrorMessage = '',
  customTitle = ''
}) => {
  const [error, setError] = useState(false)
  const [working, setWorking] = useState(false)

  const confirm = async () => {
    setWorking(true)
    setError(false)
    try {
      lateCancel ? await deleteFn(true) : await deleteFn()
    } catch (e) {
      console.error(e)

      if (setCancelWorking) {
        setCancelWorking(false)
      }

      setError(true)
    } finally {
      setWorking(false)
      closeModal()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      width='500px'
      isDesktop={isDesktop}
    >
      <DeleteAddressContainer>
        {customTitle && (
          <Header2 fontSize={32} id='custom-title'>{customTitle}</Header2>
        )}
        <Header2 fontSize={32}>{cancelConfirmText}</Header2>
        <div>
          <Button loadingColor={gsColors.sunsetOrange} onClick={closeModal} outline color={gsColors.sunsetOrange}>
            No
          </Button>
          <Button onClick={confirm} working={working} color={gsColors.sunsetOrange}>
            Yes
          </Button>
        </div>
        {customError && (
          <Text margin='1rem 0 0' variant='small' color={gsColors.sunsetOrange}>
            {customErrorMessage}
          </Text>
        )}
        {error && (
          <Text margin='1rem 0 0' variant='small' color={gsColors.sunsetOrange}>
            Something went wrong, try again
          </Text>
        )}
        {cancelSuccess &&
          <Text margin='1rem 0 0' variant='small' color={gsColors.persianGreen}>
            Your appointment has been canceled!
          </Text>
        }
      </DeleteAddressContainer>
    </Modal>
  )
}

export default DeleteModal
